module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_average_mask.b15d67d6.png";